<template>

    <!-- Google Fonts -->
    <link href="https://fonts.googleapis.com/css2?family=Seaweed+Script&amp;display=swap" rel="stylesheet">
    <link href="https://fonts.googleapis.com/css2?family=Urbanist:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&amp;display=swap" rel="stylesheet">
    <link href="https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&amp;display=swap" rel="stylesheet">

    <!-- main header -->
    <header class="main-header header-style-two">


        <!-- header-lower -->
        <div class="header-lower">
            <div class="auto-container">
                <div class="outer-box">
                    <figure class="logo-box">
                        <router-link :to="{ name: 'HomePage'}" class="brand-logo hwhite">
                            <img :src="companyLogo" alt="Site Logo" style="max-height: 60px; ">
                        </router-link>
                    </figure>
                    <div class="menu-area">
                        <!--Mobile Navigation Toggler-->
                        <div class="mobile-nav-toggler">
                            <i class="icon-bar"></i>
                            <i class="icon-bar"></i>
                            <i class="icon-bar"></i>
                        </div>
                        <nav class="main-menu navbar-expand-md navbar-light clearfix">
                            <div class="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                                <ul class="navigation clearfix">
                                    <li class="menu-item dropdown" v-for="(link, index)  in NavLinks" :key="index">
                                        <router-link :class="[JSON.parse(link.childMenu).length >0 ? 'dropdown-toggle' : '','nav-link']" :to="{ name: link.routeUrl,params:link.params}">{{link.displayText}}</router-link>
                                        <ul class="dropdown-menu" v-if="JSON.parse(link.childMenu).length > 0">
                                            <li v-for="childLink in JSON.parse(link.childMenu)">
                                                <!--<a class="dropdown-item" :href="childLink.displayText">{childLink.displayText}}</a>-->
                                                <router-link class="nav-link dropdown-item" :to="{path:childLink.routeUrl}">{{childLink.displayText}}</router-link>
                                            </li>

                                        </ul>
                                    </li>
                                    <!--<li>
                                        <Dropdown :disabled="disable" v-model="LanguageId"
                                                  :options="LanguageList"
                                                  optionValue="value"
                                                  optionLabel="text"
                                                  @change="ChangeLanguage">

                                        </Dropdown>
                                    </li>-->
                                    <!--   <li id="language-dropdown-box" class="nav-item dropdown pr-link show show-only-on-desktop">
                                        <div><span class="login-link activeLanguage" :class="lang.text" v-for=" (lang,index) in LanguageList" @click="ChangeLanguage(lang)">{{lang.text}}</span></div>
                                    </li>-->
                                </ul>
                            </div>
                        </nav>
                    </div>
                    <div class="menu-right-content" v-if="!isUserLoggedIn">

                        <div class="language-box mr_25">
                            <i class='fas fa-globe'></i>
                            <ul class="language-dropdown">
                                <li><button>English</button></li>
                                <li><button>Spanish</button></li>

                            </ul>
                        </div>
                        <div class="btn-box">
                            <ul>
                                <li class="dropdown">
                                    <a class="nav-link theme-btn btn-one" href="javascript:;" @click="login">{{$t('StoreFront.Login')}}</a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="menu-right-content" v-if="isUserLoggedIn">

                        <div class="language-box mr_25">
                            <!--<div class="icon-box"><img src="../../../../../assets/Theme/ExperienceTheme/images/flag-1.png" alt=""></div>-->
                            <i class='fas fa-globe'></i>
                            <ul class="language-dropdown">
                                <li><button>English</button></li>
                                <li><button>Spanish</button></li>
                            </ul>
                        </div>
                        <div class="btn-box">
                            <ul>
                                <li class="dropdown"  id="logout_dropdown">
                                    <router class="nav-link dropdown-toggle theme-btn btn-one" data-toggle="dropdown" href="#/dashboard" aria-expanded="true">{{$t('StoreFront.MyAccount')}}</router>
                                    <ul class="header-dropdown-menu">
                                        <li>
                                            <a class="nav-link" href="javascript:;" @click="goToPortalDashboard">{{$t('StoreFront.GoToPortal')}}</a>
                                        </li>
                                        <li>
                                            <a class="nav-link" routerlinkactive="active" @click="this.$emit('logout')" ng-reflect-router-link-active="active">{{$t('StoreFront.Logout')}}</a>
                                        </li>

                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </header>

    <!-- main-header end -->
    <header class="header-area">


        <div id="header-mobile" class="header-mobile header-navigation d-flex align-items-center" data-sticky="">



            <div class="header-mobile-center flex-grow-1">
                <div class="logo logo-mobile">
                    <a href="Javascript:;" class="brand-logo">
                        <img :src="companyLogo" alt="Site Logo" />
                    </a>
                </div>
            </div>
            <!--<div class="header-mobile-right">
            <button class="btn toggle-button-right" @click="OpenRightMenu">
                <i class="houzez-icon icon-single-neutral-circle ml-1"></i>
            </button>-->
            <!--toggle-button-right-->
            <!--<div class="main-nav navbar slideout-menu slideout-menu-right open " id="nav-mobile1" v-if="IsOpenRightMenu">

                    <ul id="mobile-main-nav" class="navbar-nav mobile-navbar-nav" v-if="isUserLoggedIn">

                        <side class="mobileMenu"></side>
                    </ul>

                </div>
            </div>-->
            <!--.header-mobile-right-->
            <div class="nav-menu">
                <!--=== Mobile Logo ===-->
                <div class="mobile-logo mb-30 d-block d-xl-none text-center">
                    <a href="Javascript:;" class="brand-logo">
                        <img :src="companyLogo" alt="Site Logo" />
                    </a>
                </div>
                <!--=== Main Menu ===-->
                <nav class="main-menu">
                    <ul>
                        <li class="menu-item dropdown" v-for="(link, index)  in NavLinks" :key="index">
                            <router-link class="nav-link" :to="{ name: link.routeUrl,params:link.params}">{{link.displayText}}</router-link>
                            <!--<ul class="dropdown-menu" v-if="JSON.parse(link.childMenu).length > 0">
                                <li v-for="childLink in JSON.parse(link.childMenu)">
                                    <a class="dropdown-item" :href="childLink.displayText">{{childLink.displayText}}</a>
                                    <router-link class="nav-link" :to="{path:childLink.routeUrl}">{{childLink.displayText}}</router-link>
                                </li>
                            </ul>-->

                        </li>

                        <li v-if="!isUserLoggedIn">
                            <a class="main-btn btn-green" @click="$emit('openLoginPage')">{{$t('StoreFront.Login/SignUp')}}</a>
                        </li>

                        <li v-if="isUserLoggedIn">
                            <a class="nav-link" href="javascript:;" @click="goToPortalDashboard">{{$t('StoreFront.GoToPortal')}}</a>
                            <a class="login-link" @click="this.$emit('logout')">{{$t('StoreFront.Logout')}}</a>
                        </li>

                    </ul>
                </nav>
            </div>
            <div class="navbar-toggler ">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>

    </header>
    <!--====== End Header ======-->


</template>



<script>
    import side from '@/views/AuthorizedUserView/AuthorizeUserLayout/SideMenu.vue'
    import service from '@/Services/frontEndService.js'

    export default {
        components: {
            side
        },
        name: 'HeaderVue',
        emits: ["openSignUpdmodel", "openLoginPage"],
        data() {
            return {
                companyLogo: '',
                IsOpenRightMenu: false,
                LanguageId: '',
                LanguageList: [],
                companySecondaryLogo: ''
            }
        },
        props: ['NavLinks', "isUserLoggedIn"],
        created() {
            this.getCompanyLogo();
            this.getlanguageList();
            if (localStorage.getItem('Language') == 'en') {
                this.LanguageId = '364697eb-c5d6-44fa-8c08-ece45aed1844';
                document.body.className = 'English';
            } else {
                this.LanguageId = 'cdf82d9b-07af-427e-9261-a3f45bc98f8f';
                document.body.className = 'Spanish';
            }
        },
        methods: {
            ChangeLanguage(event) {
                var item = this.LanguageList.find(x => x.value == event.value);
                let model = {
                    userId: localStorage.getItem("userId"),
                    companyId: localStorage.getItem("companyId"),
                    SelectedLanguage: this.LanguageId
                }
                localStorage.removeItem("Language");
                localStorage.removeItem("LanguageId");
                localStorage.setItem("Language", item.masterName);
                localStorage.setItem("languageId", item.value);
                this.$router.go(0);
                //UserService.UpdateLanguageId(model)
                //    .then(response => {
                //        //this.$toast.success("");
                //        localStorage.removeItem("Language");
                //        localStorage.setItem("Language", item.masterName);
                //        this.$router.go(0);
                //    });

            },
            getlanguageList() {
                if (this.userId == null || this.userId == undefined) {
                    this.userId = '00000000-0000-0000-0000-000000000000'
                }
                service.GetLanguageList('Language', 'Language', this.userId)
                    .then(response => {
                        this.LanguageList = response.data;



                    });
            },
            getCompanyLogo() {
                let logoUrl = localStorage.getItem('companyLogo');
                this.companyLogo = (this.$filters.IsNull(logoUrl, 'null') == 'null') ? require('../../../../../assets/images/logo/default-logo.png') : logoUrl;
                let stickylogourl = localStorage.getItem('companySecondaryLogo');
                this.companySecondaryLogo = (this.$filters.IsNull(logoUrl, 'null') == 'null') ? require('../../../../../assets/images/logo/default-logo-dark.png') : stickylogourl;
            },
            OpenRightMenu() {
                this.IsOpenRightMenu = (this.IsOpenRightMenu) ? false : true;
                let navbar = document.getElementsByClassName("navbar-default");
                let pageBodyWrapper = document.getElementsByClassName("page-body-wrapper");
                let sectionFooter = document.getElementsByClassName("section-footer");
                let footerbottom = document.getElementById('footer-bottom');
                if (this.IsOpenRightMenu) {
                    for (let i = 0; i < navbar.length; i++) {
                        navbar[i].classList.add("show-menu1");
                    }
                    for (let i = 0; i < pageBodyWrapper.length; i++) {
                        pageBodyWrapper[i].classList.add("show-menu1");
                    }
                    for (let i = 0; i < sectionFooter.length; i++) {
                        sectionFooter[i].classList.add("show-menu1");
                    }
                    // footerbottom.classList.add("show-menu1");
                } else {
                    for (let i = 0; i < navbar.length; i++) {
                        navbar[i].classList.remove("show-menu1");
                    }
                    for (let i = 0; i < pageBodyWrapper.length; i++) {
                        pageBodyWrapper[i].classList.remove("show-menu1");
                    }
                    for (let i = 0; i < sectionFooter.length; i++) {
                        sectionFooter[i].classList.remove("show-menu1");
                    }
                    //  footerbottom.classList.remove("show-menu1");
                }

            }, ToggleLeftMenu(Action = null) {
                this.IsOpenLeftMenu = (this.IsOpenLeftMenu) ? false : true;
                let navbar = document.getElementsByClassName("navbar-default");
                let pageBodyWrapper = document.getElementsByClassName("page-body-wrapper");
                let sectionFooter = document.getElementsByClassName("section-footer");
                let footerbottom = document.getElementById('footer-bottom');
                if (this.IsOpenLeftMenu) {
                    for (let i = 0; i < navbar.length; i++) {
                        navbar[i].classList.add("show-menu");
                    }
                    for (let i = 0; i < pageBodyWrapper.length; i++) {
                        pageBodyWrapper[i].classList.add("show-menu");
                    }
                    for (let i = 0; i < sectionFooter.length; i++) {
                        sectionFooter[i].classList.add("show-menu");
                    }
                    //footerbottom.classList.add("show-menu");
                } else {
                    for (let i = 0; i < navbar.length; i++) {
                        navbar[i].classList.remove("show-menu");
                    }
                    for (let i = 0; i < pageBodyWrapper.length; i++) {
                        pageBodyWrapper[i].classList.remove("show-menu");
                    }
                    for (let i = 0; i < sectionFooter.length; i++) {
                        sectionFooter[i].classList.remove("show-menu");
                    }
                    //footerbottom.classList.remove("show-menu");
                }
            },
            CloseLeftMenu() {
                if (this.IsOpenLeftMenu) {
                    let navbar = document.getElementsByClassName("navbar-default");
                    let pageBodyWrapper = document.getElementsByClassName("page-body-wrapper");
                    let sectionFooter = document.getElementsByClassName("section-footer");

                    for (let i = 0; i < navbar.length; i++) {
                        navbar[i].classList.remove("show-menu");
                    }
                    for (let i = 0; i < pageBodyWrapper.length; i++) {
                        pageBodyWrapper[i].classList.remove("show-menu");
                    }
                    for (let i = 0; i < sectionFooter.length; i++) {
                        sectionFooter[i].classList.remove("show-menu");
                    }
                    this.IsOpenLeftMenu = false

                }

            },
            goToPortalDashboard() {
                this.$emit('goToPortal')
            },
            login() {
                this.$router.push({ name: 'Login' });
            }
        }
    }
</script>